// @ngInject
function ArticleLabelsPrintDialogService($uibModal, ProductsApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog(articleId) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'ArticleLabelsPrintDialogController as vm',
            templateUrl: 'main/product/articles/articleLabelsPrintDialog/articleLabelsPrintDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            article: function () {
                return ProductsApiService.getProduct(articleId);
            }, 
            stocks: function () {
                return ProductsApiService.getProductStocks(articleId);
            }, 
            locations: function () {
                return ProductsApiService.getLocations();
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function ArticleLabelsPrintDialogController($scope, $uibModalInstance, $timeout, article, stocks, locations, ProductsApiService, FileOperationsApiService, loadSpinnerService, ResourcesService, ToasterService, $translate) {
    var vm = this;

    vm.article = angular.copy(article);;
    vm.closeModal = closeModal;
    vm.print = printData;
    vm.flexGridIsEditing = false;
    vm.ongoingRequest = false;
    vm.submittingEnabled = true;
    vm.columns = [];
    vm.rows = [];

    // ADDED STUFF FOR LOCATIONS
    vm.stockData = stocks;
    vm.stockLocations = locations;

    vm.selectedLocation = {};

    vm.getStockDataFromLocation = getStockDataFromLocation;
    vm.selectedLocationChanged = selectedLocationChanged;

    activate();

    function activate() {
        getStockDataFromLocation();
    }

    function closeModal() {
        $uibModalInstance.close();
    }

    function selectedLocationChanged(newLocation) {

        vm.selectedLocation = _.find(vm.stockLocations, function(location) {
            return location.id === newLocation.id;
        });
    }

    function getDataColumns() {
        var columns = [];

        // Group by nested variantDetail2 in the current articleVariants
        columns = _.groupBy(vm.article.articleVariants, function (variant) {
            return variant.variantDetail2.variantDetailName;
        });
        // Get the variantDetail2 from each group in an array
        columns = _.reduce(columns, function (newArray, val, key) {
            newArray.push(val[0].variantDetail2);
            return newArray;
        }, []);

        return _.sortBy(columns, 'sortOrder');
    }

    function getStockDataFromLocation() {
        var columns = [];
        var rows = [];
        
        _.forEach(getDataColumns(), function (variantDetail) {
            columns.push(variantDetail.variantDetailName);
        });

        var articleVariants = _.groupBy(vm.article.articleVariants, function(articleVariant) {
            return articleVariant.variantDetail1.variantDetailName;
        });
        _.forEach(articleVariants, function (variantRowValues) {
            var r = {};
            _.forEach(variantRowValues, function (variantRowValue) {
                r.variantDetails1Name = variantRowValue.variantDetail1.variantDetailName;

                //ADDED
                var relatedStock = getStockFor(r.variantDetails1Name, variantRowValue.variantDetail2.variantDetailName);

                if (relatedStock === undefined || relatedStock.location.id !== vm.selectedLocation.id || relatedStock['quantity'] <= 0) {
                    relatedStock = {};
                    relatedStock['quantity'] = 0;
                }
                r[variantRowValue.variantDetail2.variantDetailName] = {variant: variantRowValue, value: relatedStock.quantity };
            });
            rows.push(r);
        });

        vm.columns = columns;
        vm.rows = rows;
    }

    function getStockFor(variantDetail1Name, variantDetail2Name) {
        return _.find(vm.stockData, function(stock){ 
            return stock.articleVariant.variantDetail1.variantDetailName === variantDetail1Name &&
                   stock.articleVariant.variantDetail2.variantDetailName === variantDetail2Name  &&
                   stock.location.id === vm.selectedLocation.id;
        });
    }

    function printData() {
        if (vm.ongoingRequest) {
            return false;
        }

        vm.ongoingRequest = true;
        $uibModalInstance.startLoadingSpinner();
        var labelsRequests = [];
        var totalQty = 0;

        _.forEach(vm.rows, function (row) {
            _.forEach(vm.columns, function (column) {
                var cell = row[column];
                if (!cell || !cell.value || !cell.variant || cell.value < 0) {
                    return;
                }
                totalQty += cell.value;
                labelsRequests.push({ quantity: cell.value, articleVariantId: cell.variant.id });
            });
        });

        if (totalQty > 0) {
            ProductsApiService.downloadArticleVariantLabels(labelsRequests).then(function (response) {
                var fileName = response;
                FileOperationsApiService.downloadLabels(fileName);

            }, function (error) {
                error = handleError(error);
                if (error.message === 'Cannot save a PDF document with no pages.') {
                    ToasterService.showError($translate.instant('article.noquantity'), $translate.instant('common.error'));
                } else {
                    ToasterService.showError(error.message, $translate.instant('common.error'));
                }
            }).finally(function () {
                vm.ongoingRequest = false;
                $uibModalInstance.stopLoadingSpinner();
            });
        } else {
            vm.ongoingRequest = false;
            $uibModalInstance.stopLoadingSpinner();
        }

        function getVariant(variantDetail1Name, key) {
            return _.find(article.articleVariants, function (articleVariant) {
                return articleVariant.variantDetail1.variantDetailName === variantDetail1Name &&
                       articleVariant.variantDetail2.variantDetailName === key;
            });
        }
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

}

angular
    .module('product.articles.articleLabelsPrintDialog', [])
    .service('ArticleLabelsPrintDialogService', ArticleLabelsPrintDialogService)
    .controller('ArticleLabelsPrintDialogController', ArticleLabelsPrintDialogController);
